import React from "react";

import ProductsCard from "../cards/ProductsCard";

import data from "../../assets/data/products.json";

import { Navigation, A11y } from "swiper/modules";

import "../../assets/styles/sections/productsSection.scss";

//  $$ Swipper $$ \\
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const ProductsSection = () => {
  console.log(data);
  const startIndex = 0;
  const endIndex = 8;
  const newData = data.slice(startIndex, endIndex);
  return (
    <section className="productsSection">
      <div className="containers">
        <div className="products_items py-16">
          <div className="title text-center text-white">
            <h3 className=" font-bold text-[30px]">Products</h3>
            <p className="text-xl">Lorem, ipsum dolor.</p>
          </div>

          <div className="card_box  mt-16">
            <Swiper
              className="swiper"
              modules={[Navigation, A11y]}
              spaceBetween={20}
              // slidesPerView={3}
              breakpoints={{
                992: {
                  // spaceBetween: 40,
                  slidesPerView: 3,
                },
                768: {
                  spaceBetween: 30,
                  slidesPerView: 2,
                },
                576: {
                  // spaceBetween: 20,
                  slidesPerView: 1,
                },
              }}
              navigation
              pagination={{ clickable: true }}
              // scrollbar={{ draggable: true }}
              onSwiper={(swiper) => console.log(swiper)}
              onSlideChange={() => console.log("slide change")}
            >
              {newData.map((data, index) => (
                <SwiperSlide className="flex">
                  <ProductsCard key={data.id} data={data} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
